import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheck, FiCheckCircle, FiHeart, FiMail, FiShield } from 'react-icons/fi';
import './ExternalReview.scss';

const CONFETTI_COUNT = 14;

function ThankYou() {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    // Staggered entrance animation
    const t1 = setTimeout(() => setShowCheck(true), 200);
    const t2 = setTimeout(() => setShowContent(true), 600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div className="er">
      <div className="er__center">
        <div className="er__thankyou">
          {/* Confetti */}
          {showCheck && (
            <div className="er__confetti" aria-hidden="true">
              {Array.from({ length: CONFETTI_COUNT }).map((_, i) => (
                <span key={i} className={`er__confetti-piece er__confetti-piece--${i + 1}`} />
              ))}
            </div>
          )}

          {/* Animated Check */}
          <div className={`er__thankyou-check ${showCheck ? 'er__thankyou-check--visible' : ''}`}>
            <div className="er__thankyou-circle">
              <FiCheck size={40} strokeWidth={3} />
            </div>
            <div className="er__thankyou-ripple" />
            <div className="er__thankyou-ripple er__thankyou-ripple--delay" />
          </div>

          {/* Content */}
          <div className={`er__thankyou-content ${showContent ? 'er__thankyou-content--visible' : ''}`}>
            <div className="er__thankyou-badge">
              <FiCheckCircle size={12} />
              <span>{t('thankYou.badge')}</span>
            </div>
            <h1>{t('thankYou.title')}</h1>
            <p className="er__thankyou-subtitle">
              {t('thankYou.subtitle')}
            </p>

            <div className="er__thankyou-details">
              <div className="er__thankyou-detail">
                <span className="er__thankyou-detail-icon"><FiMail size={15} /></span>
                <span>{t('thankYou.confirmationEmail')}</span>
              </div>
              <div className="er__thankyou-detail">
                <span className="er__thankyou-detail-icon"><FiCheckCircle size={15} /></span>
                <span>{t('thankYou.feedbackRecorded')}</span>
              </div>
              <div className="er__thankyou-detail">
                <span className="er__thankyou-detail-icon"><FiShield size={15} /></span>
                <span>{t('thankYou.accessClosed')}</span>
              </div>
            </div>

            <div className="er__thankyou-footer">
              <FiHeart size={14} />
              <span>{t('thankYou.appreciation')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
